import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@app/shared/guards/auth/auth.guard';
import { MasterComponent } from '@app/layout/components/master/master.component';
import { RolesGuard } from '@app/shared/guards/roles/roles.guard';
import { HomeComponent } from './features/home/home/home.component';

const routes: Routes = [
  { path: '', redirectTo: 'inicio', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren:
      './features/authentication/authentication.module#AuthenticationModule'
  },
  {
    path: '',
    component: MasterComponent,
    canLoad: [AuthGuard],
    children: [
      {
        canActivate: [RolesGuard],
        path: 'inicio',
        component: HomeComponent
      },
      {
        canActivate: [RolesGuard],
        path: 'ordenes',
        loadChildren: './features/orders/orders.module#OrdersModule'
      },
      {
        canActivate: [RolesGuard],
        path: 'mapa',
        loadChildren: './features/maps/maps.module#MapsModule'
      },
      {
        canActivate: [RolesGuard],
        path: 'ordenes',
        loadChildren: './features/orders/orders.module#OrdersModule'
      },
      {
        path: 'mantenimientos',
        loadChildren:
          './features/maintenance/maintenance.module#MaintenanceModule'
      }
    ]
  },
  { path: '**', redirectTo: 'inicio', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
